import { useCallback } from 'react'
import {
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	mrpApiBy,
	searchApiBy
} from 'interface/endpoints'
import {
	MrpHaisinCountResult,
	MrpHaisinListResult,
	MrpLogResultList,
	MrpProjectResult,
	MrpProjectResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

const defaultRange = '1y'

export const useListMrpProject = (
	has: boolean,
	searchId: number | undefined | null,
	range: string = defaultRange
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!has || !searchId) return null
      return ApiGetWithToken<MrpProjectResultList>(
        apiAccess,
				searchApiBy(searchId, '/mrp/project/list', { t, range }),
        cancelToken
      )
    },
		[searchId, has, range]
	)
)

export const useGetMrpProject = (
	projectId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectId) return null
      return ApiGetWithToken<MrpProjectResult>(
        apiAccess,
				mrpApiBy(projectId, undefined, { t }),
        cancelToken
      )
    },
		[projectId]
	)
)

export const useListMrpLog = (
	projectId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectId) return null
      return ApiGetWithToken<MrpLogResultList>(
        apiAccess,
				mrpApiBy(projectId, '/logs', { t }),
        cancelToken
      )
    },
		[projectId]
	)
)

export const useCountMrpHaisin = (
	projectId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectId) return null
      return ApiGetWithToken<MrpHaisinCountResult>(
        apiAccess,
				mrpApiBy(projectId, '/haisin/count', { t }),
        cancelToken
      )
    },
		[projectId]
	)
)

export const useListMrpHaisin = (
	has: boolean,
	projectId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectId || !has) return null
      return ApiGetWithToken<MrpHaisinListResult>(
        apiAccess,
				mrpApiBy(projectId, '/haisin', { t }),
        cancelToken
      )
    },
		[projectId, has]
	)
)
